import { RECEIVE_HABITUAL_RESIDENCE, REQUEST_HABITUAL_RESIDENCE } from '../actions/habitual-residence'

export default (
    state = {
        fetchSuccessful: null,
        shouldFetch: true,
    },
    action
) => {
    const { type, data } = action

    switch (type) {
        case REQUEST_HABITUAL_RESIDENCE:
            return { ...state, shouldFetch: false }

        case RECEIVE_HABITUAL_RESIDENCE:
            return { ...state, ...data }

        default:
            return state
    }
}
